import { i18nMark } from 'lingui-react';

const messages = {
  serviceProvider: i18nMark('Service Provider'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/WizardSteps/ServiceProviderSelection/messages.js